import InputSearch from './InputSearch';
import './InputSearch.scss';

export default InputSearch;
